module.exports = __webpack_public_path__ + "img/game--knockout-city--pegi.37c792c5.png";